module.exports = __webpack_public_path__ + "img/icons.f5c3f5b6.svg";